/**
 * Disciplinary Warning Workflow Machine Config
 *
 * Spec: Documentation/Specification/04_Processes/application-specific/hr/DisciplinaryWarningProcess.md
 * States: draft → investigation → hearingScheduled → hearingComplete → decisionIssued → appealPeriod → closed
 */
export const disciplinaryWarningConfig = {
    id: 'disciplinary-warning',
    initial: 'draft',
    states: {
        draft: {
            on: { START_INVESTIGATION: { target: 'investigation', guard: 'investigationComplete' } },
        },
        investigation: {
            entry: { type: 'logInvestigation' },
            on: { SCHEDULE_HEARING: { target: 'hearingScheduled', guard: 'hearingNoticeGiven' } },
        },
        hearingScheduled: {
            entry: { type: 'scheduleHearing' },
            on: { HEARING_COMPLETE: 'hearingComplete' },
        },
        hearingComplete: {
            on: { ISSUE_DECISION: { target: 'decisionIssued', guard: 'decisionWithinPolicy' } },
        },
        decisionIssued: {
            entry: { type: 'issueDecision' },
            on: { APPEAL_SUBMITTED: 'appealPeriod', CLOSE: 'closed' },
        },
        appealPeriod: {
            on: { APPEAL_RESOLVED: 'closed' },
        },
        closed: {
            entry: { type: 'closeCase' },
            type: 'final',
        },
    },
};
//# sourceMappingURL=disciplinary-warning.js.map